/**
 * Reads authentication token from URL or local storage
 * @returns The authentication token or null if not found
 */
export function readToken(): string | null {
  // First check URL for token parameter (used during initial auth)
  const urlToken = new URLSearchParams(window.location.search).get("token");
  if (urlToken) {
    // Store token in localStorage for future use
    localStorage.setItem("admin_access_token", urlToken);
    return urlToken;
  }
  
  // Otherwise check localStorage
  return localStorage.getItem("admin_access_token");
}

/**
 * Stores authentication tokens in localStorage
 * @param accessToken JWT access token
 * @param refreshToken JWT refresh token
 */
export function storeTokens(accessToken: string, refreshToken: string): void {
  localStorage.setItem("admin_access_token", accessToken);
  localStorage.setItem("admin_refresh_token", refreshToken);
}

/**
 * Clears all authentication tokens from localStorage
 */
export function clearTokens(): void {
  localStorage.removeItem("admin_access_token");
  localStorage.removeItem("admin_refresh_token");
}

/**
 * Gets the stored refresh token if available
 */
export function getRefreshToken(): string | null {
  return localStorage.getItem("admin_refresh_token");
}
